import { render, staticRenderFns } from "./dedicatedDietQuestion.vue?vue&type=template&id=2f02ac95&scoped=true"
import script from "./dedicatedDietQuestion.vue?vue&type=script&lang=js"
export * from "./dedicatedDietQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f02ac95",
  null
  
)

export default component.exports